import { format, isValid, parseISO } from 'date-fns';

// DESC: Momentovi L obrasci, pretvoreni u date-fns sintaksu.
const dateFormatByLocale = {
    'en-gb': 'dd/MM/yyyy',
    hr: 'dd.MM.yyyy',
    cs: 'dd.MM.yyyy',
    de: 'dd.MM.yyyy',
    fr: 'dd/MM/yyyy',
    it: 'dd/MM/yyyy',
    hu: 'yyyy.MM.dd.',
    pl: 'dd.MM.yyyy',
    ro: 'dd.MM.yyyy',
    ru: 'dd.MM.yyyy',
    sk: 'dd.MM.yyyy',
    sl: 'dd. MM. yyyy',
    nl: 'dd-MM-yyyy',
    es: 'dd/MM/yyyy',
    nn: 'dd.MM.yyyy',
    sv: 'yyyy-MM-dd',
    uk: 'dd.MM.yyyy',
    da: 'dd.MM.yyyy',
};

// DESC: Ujednačava oznaku jezika: "en/enGB" u "en-gb", "no" u "nn",
// mala slova i crtice umjesto donjih crta. Zadani local je en-gb.
const normalizeLocale = (lang) => {
    const locale = (lang || 'en-gb')
        .toLowerCase()
        .replace(/_/g, '-');
    if (['en', 'engb'].includes(locale)) return 'en-gb';
    if (locale === 'no') return 'nn';

    return locale;
};

const parseDateValue = (value) => (typeof value === 'string' ? parseISO(value) : value);

// DESC: Formatira datum prema jeziku, uz engleski format za nepodržane jezike.
// "shortYear = false" default-no na false jer u više slučajeva koristimo "long" format datuma(shortYear: true prikazuje dvoznamenkastu godinu)
// Za nevalidan datum vraća prazan string.
export const formatLocalizedDate = (
    value,
    lang,
    { shortYear = false } = {},
) => {
    const date = parseDateValue(value);
    if (!isValid(date)) return '';
    const localeKey = normalizeLocale(lang);
    const fullYearFormat = dateFormatByLocale[localeKey] ?? dateFormatByLocale['en-gb'];
    const dateFormat = shortYear ? fullYearFormat.replace(/yyyy/g, 'yy') : fullYearFormat;

    return format(date, dateFormat);
};

// DESC: Formatira datum kao yyyy-MM-dd za URL i API zahtjeve, za nevalidan datum vraća prazan string.
export const formatDateForRequest = (value) => {
    const date = parseDateValue(value);

    return isValid(date) ? format(date, 'yyyy-MM-dd') : '';
};
